import { render } from "./DocCompHosting.vue?vue&type=template&id=71e5ca8b"
import script from "./DocCompHosting.vue?vue&type=script&lang=js"
export * from "./DocCompHosting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__